import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TbPdfPreviewService {

  constructor(private http: HttpClient) {}

  doesTaxFormExist(pdfEngineUrl: string, formName: string, taxYear: string, formType: string = ''): Observable<any> {
    const url = `${pdfEngineUrl}/doesTaxFormExist?irs_form_no=${formName}&tax_year=${taxYear}&formType=${formType}`;
    return this.http.post<any>(url, {}, {
      withCredentials: true,
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  fillFormPorforma(
    pdfEngineUrl: string,
    formName: string,
    entity: string,
    s3Url: string,
    formSubCat: string,
    taxYear: string,
    cdrNo: string,
    rptPeriod: string | number,
    leType: string,
    systemFlag: string,
    scenario: string,
    leName: string = '',
    ein: string = '',
    schedule: string = '',
    line: string = '',
    partNo: string = 'NA',
    selectedEntityType: string = '',
    selectedConsolGroup: string = '',
    formSub: string = '',
    irsFormName: string = ''
  ): Observable<ArrayBuffer> {
    let adjustedLeType = leType;
    if (adjustedLeType === 'PSHIP') {
      adjustedLeType = 'HO';
    }

    const url = `${pdfEngineUrl}/fillFormPorforma`
      + `?irs_parent_form_no=${irsFormName}`
      + `&irs_form_no=${formName}`
      + `&s3_url=${s3Url}`
      + `&form_sub_cat=${formSubCat}`
      + `&form_sub=${formSub}`
      + `&entity=${entity}`
      + `&tax_year=${taxYear}`
      + `&cdr_no=${cdrNo}`
      + `&rpt_period=${rptPeriod}`
      + `&le_type=${adjustedLeType}`
      + `&system_flag=${systemFlag}`
      + `&jcdKey=250`
      + `&scenario=${scenario}`
      + `&leName=${leName}`
      + `&ein=${ein}`
      + `&schedule=${schedule}`
      + `&line=${line}`
      + `&part=${partNo}`
      + `&entity_type=${selectedEntityType}`
      + `&cgkey=${selectedConsolGroup}`;

    return this.http.post(url, null, {
      responseType: 'arraybuffer',
      withCredentials: true
    });
  }

  fillNewProformaForm(
    pdfEngineUrl: string,
    irsFormNo: string,
    s3Url: string,
    formSubCat: string,
    leid: string,
    taxYear: string,
    cdrNo: string,
    rptPeriod: string | number,
    systemFlag: string,
    scenario: string,
    formSub: string = '',
    parentLeId: string = '',
    wpIrsFormNo: string = '',
    schedule: string = '',
    line: string = '',
    partNo: string = 'NA',
    leName: string = '',
    leType: string = 'HO',
    ein: string = '',
    jcdKey: string = '250',
    srcType: string = 'DOM',
    jobId: string = '',
    entityType: string = '',
    cgKey: string = '',
    consolType: string = '',
    keyId: string = '',
    formType: string = ''
  ): Observable<ArrayBuffer> {
    let adjustedEntityType = entityType;
    if (adjustedEntityType === 'ALL') {
      adjustedEntityType = '';
    }

    let params = new HttpParams()
      .set('irsFormNo', irsFormNo)
      .set('s3Url', s3Url)
      .set('formSubCat', formSubCat)
      .set('formSub', formSub)
      .set('leid', leid)
      .set('parentLeId', parentLeId)
      .set('taxYear', taxYear)
      .set('cdrNo', cdrNo)
      .set('rptPeriod', String(rptPeriod))
      .set('systemFlag', systemFlag)
      .set('wpIrsFormNo', wpIrsFormNo)
      .set('schedule', schedule)
      .set('line', line)
      .set('partNo', partNo)
      .set('leName', leName)
      .set('leType', leType)
      .set('ein', ein)
      .set('jcdKey', jcdKey)
      .set('scenario', scenario)
      .set('srcType', srcType)
      .set('jobId', jobId)
      .set('entity_type', adjustedEntityType)
      .set('cgKey', cgKey)
      .set('consolType', consolType)
      .set('keyId', keyId)
      .set('formType', formType);

    const url = `${pdfEngineUrl}/fillNewProformaForm2`;

    return this.http.get(url, {
      responseType: 'arraybuffer',
      withCredentials: true,
      params: params
    });
  }
}
